import { useSelector } from 'react-redux';
import { State } from '../reducers';

export const useEstateConfig = () => {
  return useSelector((state: State) => state.config.config?.estateService)
}

export const useInboxConfig = () => {
  return useSelector((state: State) => state.config.config?.inboxService);
}

export const useInvoiceConfig = () => {
  return useSelector((state: State) => state.config.config?.invoiceService);
}

export const usePropertyTaxConfig = () => {
  return useSelector((state: State) => state.config.config?.propertyTaxService);
}

export const useSweepingConfig = () => {
  return useSelector((state: State) => state.config.config?.sweepingService);
}

export const useProfileConfig = () => {
  return useSelector((state: State) => state.config.config?.profileService);
}

export const useWaterSewageConfig = () => {
  return useSelector((state: State) => state.config.config?.waterAndWasteService);
}